"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";

export function WebsocketListener() {
  const router = useRouter();
  useEffect(() => {
    console.log("establishing websocket connection");
    const ws = new WebSocket(process.env.NEXT_PUBLIC_SOCKET_URL as string);

    ws.onmessage = (event) => {
      console.log("WebSocket message received:", event.data);
      router.refresh();
    };

    return () => {
      console.log("closing websocket connection");
      ws.close();
    };
  }, [router]);

  return null;
}
